<template>
  <div class="content">
    <div class="header">
      <el-button @click="pageChange(1)">查询</el-button>
      <el-button @click="setComponents('CustomerRentEditor')">新增出租</el-button>
<!--      <el-button @click="setComponents('SaleCarryOver')">结转资金</el-button>-->
      <el-button @click="goExcel(1)">批量新增出租</el-button>
      <el-button @click="goExcel(0)">导入历史租户信息</el-button>
    </div>
    <div class="header-where">
      <el-descriptions size="mini" direction="vertical" :column="1" border>
        <el-descriptions-item label="查询条件">
          <el-descriptions size="mini" :column="2" border>
            <el-descriptions-item label="房产范围">
              {{where.house_name}}
            </el-descriptions-item>
            <el-descriptions-item label="出租状态">
              <el-checkbox-group v-model="where.isCeased">
                <el-checkbox :label="1">当前出租记录</el-checkbox>
                <el-checkbox :label="0">历史出租记录</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="业主名称">
              <el-input size="mini" v-model="where.txtOwnerName" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="承租时间">
              <el-date-picker
                style="width: 150px"
                v-model="where.txtBeginBeginDate"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              至
              <el-date-picker
                style="width: 150px"
                v-model="where.txtBeginEndDate"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="承租人">
              <el-input size="mini" v-model="where.txtRentCustomerName" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="退租时间">
              <el-date-picker
                style="width: 150px"
                v-model="where.txtCeasedBeginDate"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              至
              <el-date-picker
                style="width: 150px"
                v-model="where.txtCeasedEndDate"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="房号">
              <el-input size="mini" style="width: 180px;" v-model="where.HouseNumber" clearable></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="body">
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%">
          <el-table-column
            prop="house_name"
            label="房产" width="320">
            <template slot-scope="scope">
              <el-link type="primary" @click="setComponents('CustomerRentEditor',scope.row.id)">{{scope.row.house_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="is_ceased"
            label="出租状态"
            width="100">
            <template slot-scope="scope">
              {{scope.row.is_ceased?'当前':'历史'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="rent_customer_name"
            label="承租人"
            width="150">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEditor(scope.row.rent_customer_id)">{{scope.row.rent_customer_name}}</el-link>
            </template>
          </el-table-column>

          <el-table-column
            prop="rent_customer_text"
            label="家庭成员"
            width="150">
            <template slot-scope="scope">
                <div v-for="familys in scope.row.family">
                  {{familys.name}}({{getRelationText(familys.relation)}})
                </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="customer_name"
            label="业主名称"
            width="150">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEditor(scope.row.customer_id)">{{scope.row.customer_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="contract_id"
            label="合同编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="begin_date"
            label="承租日期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="cease_date"
            label="退租日期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="payment_name"
            label="缴费对象"
            width="100">
          </el-table-column>
          <el-table-column
            prop="op_user_name"
            label="操作人"
            width="100">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>

    <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />
  </div>
</template>

<script>
import Editor from "../../../Customer/editor";

export default {
  name: "CustomerRentMain",
  components:{Editor},
  inject:["mainObj","setComponentsId"],
  data(){
    return{
      where:{
        house_id:"",
        house_name:"",
        isCeased:[1,0],
        txtOwnerName:"",
        txtBeginBeginDate:"",
        txtBeginEndDate:"",
        txtRentCustomerName:"",
        txtCeasedBeginDate:"",
        txtCeasedEndDate:"",
        HouseNumber:"",
      },
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
      relationList: [{"value":"1","label":"夫妻"},{"value":2,"label":"父子"},{"value":3,"label":"父女"},{"value":4,"label":"母子"},{"value":5,"label":"母女"},{"value":6,"label":"其他"},{"value":7,"label":"亲戚朋友"},{"value":8,"label":"租户"},{"value":9,"label":"叔叔侄子"},{"value":10,"label":"侄子叔叔"}],
    }
  },
  activated() {
    this.where.house_id=this.house_id;
    this.where.house_name=this.house_name;
    this.getList()
  },
  watch: {
    house_id(n,o){
      this.where.house_id=n;
    },
    house_name(n,o){
      this.where.house_name=n;
      this.pageChange(1)
    }
  },
  computed:{
    house_id(){
      return (this.mainObj||{}).house_id||''
    },
    house_name(){
      return (this.mainObj||{}).house_name||''
    },
  },
  methods:{
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that=this;
      let where={
        ...that.where,
        pageSize:that.pageData.pageSize,
        page:that.pageData.page,
      }
      ERP.postRequest({url:"admin/HouseRent/getList",data:where},ret=>{
        if(ret.code){
          that.pageData=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    showEditor(customer_id) {
      const that=this;
      that.getCustomerBase(customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    setComponents(componentsId,id=""){
      this.mainObj.rent_id=id;
      this.setComponentsId(componentsId)
    },
    goExcel(is_ceased=0){
      this.mainObj.excel_type=is_ceased;
      this.setComponentsId("CustomerRentBatch")
    },
    getRelationText(val) {
      if(val == 0) return "户主本人"
      for(let k in this.relationList) {
        if(this.relationList[k].value == val) {
          return this.relationList[k].label
        }
      }
      return "-"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/CustomerRentMain.vue